import React from 'react';
import { Route } from 'react-router-dom';
import { AuthContext } from '@shared/contexts';
import config from '@config';
import { getRCRedirectUri } from '@utils';

/**
 * Route component that ensures authorization for protected routes.
 */
export default ({ component: Component, currentUser, ...rest }) => {
  const { isAuthenticated } = React.useContext(AuthContext);
  const { rc_client_Id, rc_authorize_uri, apiBaseUrl } = config;

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthenticated) {
          return <Component {...props} />;
        } else {
          window.location.replace(
            getRCRedirectUri(
              rc_authorize_uri,
              rc_client_Id,
              apiBaseUrl,
              window.location.href
            )
          );
        }
      }}
    />
  );
};
